module.exports = __webpack_public_path__ + "img/imageIsRestricted.dc6efdd4.svg";